export default "__VITE_ASSET__DapKuoFn__"